<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const store = useStore();
const { t } = useI18n();

const calendarState = computed(
  () => store.getters['painelCalendar/getCalendarState']
);
const isSyncing = computed(() => store.getters['painelCalendar/isSyncing']);

const tick = ref(0);
let interval;
onMounted(() => {
  tick.value = 1;
  interval = setInterval(() => {
    tick.value += 1;
  }, 30000);
});
onUnmounted(() => clearInterval(interval));

const distance = computed(() => {
  // Reference tick.value to re-evaluate this computed every 30s
  const state = tick.value >= 0 ? calendarState.value : null;
  if (!state?.last_sync_at) return null;
  return formatDistanceToNow(new Date(state.last_sync_at), {
    addSuffix: true,
    locale: ptBR,
  });
});

const refresh = () => store.dispatch('painelCalendar/resync');
</script>

<template>
  <div
    class="flex flex-wrap items-center justify-between gap-2 border-t border-n-slate-3 pt-3 text-xs text-n-slate-11"
  >
    <div class="flex flex-wrap items-center gap-2">
      <span v-if="isSyncing">{{
        t('PAINEL.APPOINTMENTS.SIDEBAR.SYNCING')
      }}</span>
      <span v-else-if="distance">{{
        t('PAINEL.APPOINTMENTS.SIDEBAR.SYNCED_AGO', { time: distance })
      }}</span>
      <span v-else>{{ t('PAINEL.APPOINTMENTS.SIDEBAR.NEVER_SYNCED') }}</span>
    </div>
    <button
      class="text-n-brand hover:underline disabled:opacity-40"
      :aria-label="t('PAINEL.APPOINTMENTS.SIDEBAR.REFRESH')"
      :disabled="isSyncing"
      @click="refresh"
    >
      <svg
        class="h-3.5 w-3.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
        />
      </svg>
    </button>
  </div>
</template>
